import { useRateManagement } from '@api/useFreight/useFreight'
import type { ManualAccessorial } from '@api/useFreight/types'
import { type BaseScheduleButtonProps, ScheduleRateButton } from './BaseScheduleRateButton'

// Props for Manual Accessorial Schedule Button
export interface ManualAccessorialScheduleButtonProps extends BaseScheduleButtonProps {
  accessorial: ManualAccessorial
}

// Manual Accessorial Schedule Button
export function ManualAccessorialScheduleButton(props: ManualAccessorialScheduleButtonProps) {
  const { useCreateManualAccessorialRate } = useRateManagement()
  const createManualAccessorialRateMutation = useCreateManualAccessorialRate()

  const createRate = async (data: {
    accessorial_id: string
    effective_from_date: string
    effective_to_date?: string
    rate: number
  }): Promise<void> => {
    await createManualAccessorialRateMutation.mutateAsync({
      accessorial_id: data.accessorial_id,
      effective_from_date: data.effective_from_date,
      effective_to_date: data.effective_to_date,
      rate: data.rate,
    })
  }

  return (
    <ScheduleRateButton
      {...props}
      isLoading={createManualAccessorialRateMutation.isPending}
      createRate={createRate}
      invalidateQueryKey={['manual_accessorials']}
      hideEndDate={true}
    />
  )
}
